/** Build a 2-decimal currency formatter for the given ISO 4217 currency code,
 *  falling back to a plain numeric format if the code is not recognized. */
export function makeCurrencyFormatter(currency: string): (value: number) => string {
    try {
        const fmt = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        return (value) => fmt.format(value);
    } catch {
        return (value) => `${value.toFixed(2)} ${currency}`;
    }
}
